module.exports = __webpack_public_path__ + "static/media/Logo__JPMC.da29b643.svg";